import { CoreToolboxComponentIds } from "../CoreToolboxComponentIds";
/**
 * Used by the DebugSurface systems to hold a reference to the viewer objects
 * that are created when drawing debug surfaces.
 */
var ViewerSurfaceReferenceComponent = /** @class */ (function () {
    function ViewerSurfaceReferenceComponent(viewerObjects) {
        this.viewerObjects = viewerObjects;
        this.typeId = ViewerSurfaceReferenceComponent.ID;
        this.serializable = false;
        this.doStoreInSnapshot = false;
    }
    ViewerSurfaceReferenceComponent.prototype.eq = function (other) {
        // If they're not equal length, they're not the same.
        if (this.viewerObjects.length !== other.viewerObjects.length) {
            return false;
        }
        // If they are the same length...
        for (var i = 0; i < this.viewerObjects.length; i++) {
            // But do not contain the same ID
            var thisId = this.viewerObjects[i].getViewerObjectId();
            var otherId = other.viewerObjects[i].getViewerObjectId();
            if (thisId !== otherId) {
                return false;
            }
        }
        return true;
    };
    ViewerSurfaceReferenceComponent.ID = CoreToolboxComponentIds.ViewerSurfaceReferenceComponent;
    return ViewerSurfaceReferenceComponent;
}());
export { ViewerSurfaceReferenceComponent };
//# sourceMappingURL=ViewerSurfaceReferenceComponent.js.map